import { SiteHeaderComponent } from "./layout/site-header/site-header.component";
import { SiteFooterComponent } from "./layout/site-footer/site-footer.component";

export const components: any[] = [SiteHeaderComponent, SiteFooterComponent];

export * from "./layout/site-header/site-header.component";
export * from "./layout/site-footer/site-footer.component";
